/**
 * Centralized registry of all feature flags.
 * This ensures type safety and consistency with backend feature flag keys.
 */
export const FEATURE_FLAGS = {
  SCHOLARSHIPS: 'scholarships',
  FEEDBACK_SYSTEM: 'feedback_system',
  ONLINE_PAYMENTS: 'online_payments',
} as const;
